import '../styles/footer.css';

import { NavLink } from 'react-router-dom';
import React from 'react';

const Footer = () => {
  return (
    <div className="footer">
      <div className="navMenuFooter">
        <NavLink to="/" className={`navMenuItem`}>
          Home
        </NavLink>
        <NavLink to="/roadmap" className={`navMenuItem`}>
          Roadmap
        </NavLink>
        <NavLink to="/news" className={`navMenuItem`}>
          News
        </NavLink>
        <NavLink to="/faqs" className={`navMenuItem`}>
          FAQ's
        </NavLink>
      </div>

      <div className="copyrightText">
        This website displays Responsive Design on computers, tablets, and
        cellphones!
      </div>
      <div className="copyrightText">
        &copy;2022 James L. Avakian, Optical Automation, LLC. All rights
        reserved.
      </div>
    </div>
  );
};

export default Footer;
